import {
  END_CTA_FLOW,
  END_CUSTOM_THUMBNAIL_FLOW,
  END_VIDEO_SETTINGS_FLOW,
  FINISH_THUMBNAIL_SAVE,
  INITIATE_THUMBNAIL_SAVE,
  SET_LOCAL_THUMBNAIL,
  START_CTA_FLOW,
  START_CUSTOM_THUMBNAIL_FLOW,
  START_VIDEO_SETTINGS_FLOW,
  TOGGLE_THUMBNAIL_UPLOADING,
} from 'constants/actions';

export const _startThumbnailFlow = () => {
  return { type: START_CUSTOM_THUMBNAIL_FLOW };
};

export const startThumbnailFlow = () => dispatch => {
  dispatch(_startThumbnailFlow());
};

export const endThumbnailFlow = () => {
  return { type: END_CUSTOM_THUMBNAIL_FLOW };
};

export const _startCTAFlow = () => {
  return { type: START_CTA_FLOW };
};

export const startCTAFlow = () => dispatch => {
  dispatch(_startCTAFlow());
};

export const endCTAFlow = () => {
  return { type: END_CTA_FLOW };
};

export const _startVideoSettingsFlow = () => {
  return { type: START_VIDEO_SETTINGS_FLOW };
};

export const startVideoSettingsFlow = () => dispatch => {
  dispatch(_startVideoSettingsFlow());
};

export const endVideoSettingsFlow = () => {
  return { type: END_VIDEO_SETTINGS_FLOW };
};

export const initiateThumbnailSave = () => {
  return { type: INITIATE_THUMBNAIL_SAVE };
};

export const finishThumbnailSave = () => {
  return { type: FINISH_THUMBNAIL_SAVE };
};

export const setLocalThumbnail = (url, dims) => {
  return { type: SET_LOCAL_THUMBNAIL, url, dims };
};

export const toggleThumbnailUploading = () => {
  return { type: TOGGLE_THUMBNAIL_UPLOADING };
};
